import axios from 'axios';
import Environment from "@/services/environment.service";

export default class HttpService {
  environment = new Environment();

  getUrl(path) {
    return this.environment.getHost() + path
  }

  post (path, body) {
    return new Promise((resolve, reject) => {
      axios.post(this.getUrl(path), body, {
        headers: {}
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err.response.data)
      })
    })
  }
}